























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import JustifyService from '@/domain/justify/service/justify.service';
import { JustifyType } from '@/domain/justify/domain/justify-type.enum';
import Justify from '@/domain/justify/domain/justify.entity';
import InstanceJustificationAdd from '@/domain/contract/entity/instance-justification-add.entity';
import InstanceService from '@/domain/contract/service/instance.service';
import UnboundInstance from '@/domain/contract/entity/unbound-instance.entity';
import Rules from '@/shared/rules/rules';

@Component
export default class InstanceDataTable extends Vue {
  @Prop({ type: Boolean, default: false })
  value!: boolean;

  @Prop({ type: Array, default: () => ([]) })
  selectedInstances!: Array<UnboundInstance>;

  loadingJustifications: boolean = false;

  justifications: Justify[] = [];

  addingJustification = new InstanceJustificationAdd();

  loadingSave: boolean = false;

  rules = new Rules();

  closeDialog(): void {
    this.$emit('input', false);
  }

  validateAndSave(): void {
    const { form }: any = this.$refs;
    if (!form.validate()) return;
    this.saveJustification();
  }

  saveJustification() {
    const instanceIds = this.selectedInstances.map((it) => it.id);
    this.loadingSave = true;
    InstanceService.addJustification(instanceIds, this.addingJustification)
      .then(() => {
        this.closeDialog();
        this.$emit('added');
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => { this.loadingSave = false; });
  }

  clear(): void {
    this.addingJustification = new InstanceJustificationAdd();
  }

  created(): void {
    this.loadingJustifications = true;
    JustifyService.getJustificationsByType(JustifyType.INSTANCE_INTEGRATION_INACTIVATION)
      .then((justifications: Justify[]) => {
        this.justifications = justifications;
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => { this.loadingJustifications = false; });
  }
}
